<template>
  <div>
    <div class="location-store">
      <StoresDropdown
        :filiale="filiale"
        :all-included="'All'"
        @updateFiliale="updateFiliale"
      />
      <vue-select
        v-model="locationByStore"
        :options="filiale?.storeId != null ? getLocationsByStoreIdName : getLocationsMoving"
        label="locationName"
        :reduce="(e) => e.locationId"
        :placeholder="$t('Location')"
        style="flex-basis: 25%"
        @input="updateLocation"
      />
    </div>
    <div style="display: flex; gap: 20px;border-top: 1px solid #EAE9EA;">
      <div style="width:65%">
        <div>
          <table
            class="team_table"
          >
            <thead>
              <tr>
                <th>
                  {{ $t("No") }}
                </th>
                <th>
                  {{ $t("Barcode") }}
                </th>
                <th>
                  {{ $t('ArticleNumber') }}
                </th>
                <th>
                  {{ $t('Quantity') }}
                </th>
                <th>
                  {{ $t('Price') }}
                </th>
                <th>
                  {{ $t('Photo') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('sellableProductsSidebar')"
              :cols="12"
              :response-data="getProductStockSellSidebar"
            >
              <tr
                v-for="(products, index) in getProductStockSellSidebar"
                :key="index"
                v-b-tooltip.hover
                class="hover-row"
                :style="colorOfTrow === products.inventoryProductId ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
                style="cursor:pointer"
                :title="disabledRows ? $t('SelectStore') : $t('ClickToSeeLocation')"
                :class="{ disabled: filiale?.storeId == null || filiale?.storeId === '00000000-0000-0000-0000-000000000000' }"
                @click="showAllLocations(products)"
              >
                <td>
                  {{ getsellableProductsSidebarTotalItems - (pageNumber - 1) * pageSize - index }}.
                </td>
                <td>
                  <div style="display:flex;gap:5px;align-items: center;">
                    <img
                      v-if="products.barcode"
                      v-b-tooltip.hover.bottom
                      :title="$t('DownloadBarcode')"
                      style="cursor:pointer;"
                      src="../../assets/images/pdf-invoice-logo.svg"
                      @click.stop="downloadBARCODE(products.barcode);"
                    >
                    <p v-else>
                      {{ $t('NoBarcode') }}
                    </p>
                  </div>
                </td>
                <td>{{ products.articleNumber }}</td>
                <td>{{ products.quantity || 0 }}</td>
                <td>{{ products.sellPrice || 0 }}</td>
                <td v-if="products?.fileUrl">
                  <img
                    v-b-tooltip="$t('ClickToViewPhoto')"
                    style="height: 40px; border-radius: 3px;cursor:pointer; "
                    :src="products.fileUrl"
                    alt=""
                    @click.stop="showImage(products.fileUrl)"
                  >
                </td>
                <td v-else>
                  {{ $t('NoImageOrDocument') }}
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
        </div>
        <div>
          <b-pagination
            v-if="getsellableProductsSidebarTotalItems > 15"
            v-model="pageNumber"
            :total-rows="getsellableProductsSidebarTotalItems"
            :per-page="pageSize"
            first-number
            last-number
            align="fill"
            size="md"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="updatePage"
          >
            <template #prev-text>
              <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
            </template>
            <template #next-text>
              <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
            </template>
          </b-pagination>
        </div>
      </div>
      <div style="width:35%">
        <div>
          <table
            class="team_table"
            style="width: 100%; box-shadow: none; font-size: 13px;cursor:auto"
          >
            <thead>
              <tr>
                <th>
                  {{ $t('Location') }}
                </th>
                <th>
                  {{ $t('Quantity') }}
                </th>
                <th>
                  {{ $t('Add') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('totalStockGroupedByLocationSidebar')"
              :response-data="getTotalStockGroupByLocationSidebar"
            >
              <tr
                v-for="(article, index) in getTotalStockGroupByLocationSidebar"
                :key="index"
              >
                <td>{{ article.locationName }}</td>
                <td>{{ article.quantity }}</td>
                <td>
                  <button
                    v-b-modal.is-article-pending-modal
                    class="primary"
                    @click="isArticle(article)"
                  >
                    {{ $t('Add') }}
                  </button>
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
          <IsArticlePendingModal
            :clicked-article="clickedArticle"
            :clicked-location="clickedLocation"
            :amount-of-product="amountOfProduct"
            :clicked-product-id="clickedProductId"
            @updateProductsInStockPending="updateProductsInStockPendings"
          />
        </div>
      </div>
    </div>
    <vue-easy-lightbox
      :esc-disabled="false"
      :visible="image.visible"
      :imgs="image.imgs"
      :index="image.index"
      @hide="handleHide"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import JsBarcode from 'jsbarcode';
import StoresDropdown from '@/components/StoresDropdown.vue';
import VueEasyLightbox from 'vue-easy-lightbox'
import IsArticlePendingModal from './modals/IsArticlePendingModal.vue';


export default {
  components: {
    StoresDropdown,
    VueEasyLightbox,
    IsArticlePendingModal,
  },
  data() {
    return {
      filiale: {
        storeId: null,
        storeName: 'No filiale',
        storeGLN: null,
      },
      locationByStore: null,
      pageNumber: 1,
      pageSize: 15,
      image: {
        zoom: 1,
        imgs: [],
        visible: false,
        index: 0,
      },
      isPageNumberChanged: false,
      isUserChangingPage: false,
      colorOfTrow: '',
      clickedArticle: null,
      clickedLocation: null,
      clickedProductId: null,
      amountOfProduct: null,
      disabledRows: false,
      clickedInventoryProductId: null,
    }
  },
  computed: {
    ...mapGetters([
      'getProductStockSellSidebar',
      'getsellableProductsSidebarTotalItems',
      'getLocationsByStoreIdName',
      'getLocationsMoving',
      'getTotalStockGroupByLocationSidebar',
    ]),
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      'resetTotalStockGroupedByLocationSidebar',
      'totalStockGroupedByLocationSidebar',
      'sellableProductsSidebar',
      'movingLocations',
      'loadLocationsByStoreIdName',
      'loadIsProductInTransit',
    ]),
    updateProductsInStockPendings() {
      this.totalStockGroupedByLocationSidebar({
        inventoryProductId: this.clickedInventoryProductId,
        storeId: this.filiale.storeId,
      })
    },
    isArticle(value) {
      this.loadIsProductInTransit({
        productInStockId: value.productInStockId,
      })
      this.clickedLocation = value.locationName
      this.amountOfProduct = value.quantity
      this.clickedProductId = value.productInStockId
    },
    showAllLocations(value) {
      if (this.disabledRows) {
        return
      }
      this.colorOfTrow = value.inventoryProductId
      this.clickedArticle = value.articleNumber
      this.clickedInventoryProductId = value.inventoryProductId
      this.totalStockGroupedByLocationSidebar({
        inventoryProductId: value.inventoryProductId,
        storeId: this.filiale.storeId,
      })
    },
    updateLocation(value) {
      this.pageNumber = 1
      this.sellableProductsSidebar({
        storeId: this.filiale.storeId,
        pageNumber: 1,
        pageSize: this.pageSize,
        inventoryProductId: null,
        searchFilter: null,
        locationId: value,
      })
      this.colorOfTrow = ''
      this.resetTotalStockGroupedByLocationSidebar()
    },
    updatePage(value) {
      this.sellableProductsSidebar({
        storeId: this.filiale.storeId,
        pageNumber: value,
        pageSize: this.pageSize,
        inventoryProductId: null,
        searchFilter: null,
        locationId: this.locationByStore,
      })
      this.colorOfTrow = ''
      this.resetTotalStockGroupedByLocationSidebar()
    },
    updateFiliale(newFiliale) {
      if (newFiliale?.storeId === null || newFiliale?.storeId === '00000000-0000-0000-0000-000000000000') {
        this.disabledRows = true
      } else {
        this.disabledRows = false
      }
      this.filiale = newFiliale;
      this.pageNumber = 1
      this.locationByStore = null
      this.sellableProductsSidebar({
        storeId: newFiliale.storeId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        inventoryProductId: null,
        searchFilter: null,
        locationId: this.locationByStore,
      })
      if (newFiliale.storeId) {
        this.loadLocationsByStoreIdName({
          storeId: newFiliale.storeId,
        })
        this.$store.commit('SET_LOCATIONS_MOVING', []);
      } else {
        this.movingLocations()
        this.$store.commit('SET_LOCATIONS_BY_STOREID_NAME', []);
      }
      this.colorOfTrow = ''
      this.resetTotalStockGroupedByLocationSidebar()
    },
    async generateAndDownloadBarCode() {
      const value = this.articleNumberBarCode;

      try {
        const canvas = document.createElement('canvas');

        // Check if the value can be an EAN-13 barcode (must be 12 or 13 digits)
        let format = 'CODE128'; // Default to CODE128

        // EAN-13 format check: Should be a 13-digit number
        if (/^\d{12,13}$/.test(value)) {
          format = 'EAN13';
        }

        // Generate the barcode with the chosen format
        JsBarcode(canvas, value, { format });

        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = `Barcode - ${value}.png`;
        link.click();
      } catch (error) {
        console.error('Error generating barcode:', error);
      }
    },
    downloadBARCODE(value) {
      this.articleNumberBarCode = value
      this.generateAndDownloadBarCode();
    },
    async showImage(fileUrl) {
      this.image.imgs = fileUrl;
      this.image.visible = true
    },
    handleHide() {
      this.image.visible = false
      this.image.imgs.length = []
    },
  },
}
</script>

<style scoped>
  .location-store {
    display: flex;
    gap:15px;
    border: 1px solid #EAE9EA;
    border-bottom: transparent;
    padding: 12px;
  }
  .hover-row:hover {
      background-color: rgba(255, 39, 79, 0.1);
  }
  .disabled {
  cursor: not-allowed !important;
}
</style>
